import Vue from "vue";
import App from "./App";
import router from './router/index';
// import mock from './mock/index';
// import Antd from 'ant-design-vue'
import {
  Layout, Icon, Menu, Avatar, Button, Modal, Table, Divider, Popconfirm,
  Form, Input, InputNumber, Upload, Popover, Select, message, Tooltip, Row, Col,
  Dropdown, TreeSelect, Switch, DatePicker, Drawer, AutoComplete, Progress, Steps,
  TimePicker, Checkbox, Carousel, Radio
} from 'ant-design-vue';
import store from './store/index'
import 'ant-design-vue/dist/antd.less'
import vueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import katex from 'katex';
import 'katex/dist/katex.min.css';
import VueDND from 'awe-dnd'

Vue.use(VueDND)
// Vue.use(Antd)
Vue.use(vueQuillEditor)
Vue.use(katex)
Vue.use(Layout)
Vue.use(Icon)
Vue.use(Menu)
Vue.use(Avatar)
Vue.use(Button)
Vue.use(Modal)
Vue.use(Table)
Vue.use(Divider)
Vue.use(Popconfirm)
Vue.use(Form)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Upload)
Vue.use(Popover)
Vue.use(Select)
Vue.use(message)
Vue.use(Tooltip)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dropdown)
Vue.use(TreeSelect)
Vue.use(Switch)
Vue.use(DatePicker)
Vue.use(Drawer)
Vue.use(AutoComplete)
Vue.use(Progress)
Vue.use(Steps)
Vue.use(TimePicker)
Vue.use(Checkbox)
Vue.use(Carousel)
Vue.use(Radio)
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$info = Modal.info;

Vue.config.productionTip = false;

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default vm